import '../../css/shared/shared-style.css';
// import foo from './bar'
import './legacy';
